import { InputHTMLAttributes, forwardRef } from 'react';
import { currencyFormat } from '../../../utils/src/currency/currencyFormat';
import { Input } from './Input';

interface InputCurrencyStandaloneProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
  value: string;
  onChange: (value: string) => void;
}

const InputCurrencyStandalone = forwardRef<HTMLInputElement, InputCurrencyStandaloneProps>((props, ref) => {
  const { value, onChange, ...rest } = props;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const digitsOnly = e.target.value.replace(/\D/g, '');
    onChange(digitsOnly);
  };

  const displayValue = value ? currencyFormat(value) : '';

  return (
    <Input
      ref={ref}
      {...rest}
      value={displayValue}
      onChange={handleChange}
      placeholder="R$ 0,00"
    />
  );
});

InputCurrencyStandalone.displayName = 'InputCurrencyStandalone';

export { InputCurrencyStandalone };
